/* eslint-disable */
import axios from '../axios-config';
import router from '../router/index';
import { Mutex } from 'async-mutex';
import store from '../store/store';
import options from './options'
import logger from '../services/logger';
import { EVENT_ADDED } from '../../node_modules/@okta/okta-auth-js';

export default {
  install(Vue) {
    const mutex = new Mutex();
    const callbackUrlSessionItem = options.authentication.session.callbackUrlSessionItem;
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        //console.log('This page was restored from the bfcache.');
      } else {
       // console.log('This page was loaded normally.');
      }
    });
    window.addEventListener('storage', async (event) => {
      const token = await Vue.prototype.$auth.tokenManager.get('accessToken');
      const currentUserId = sessionStorage.getItem('userId');
      if (token &&token.accessToken 
       && token.claims.userid && event.key === 'okta-token-storage'
       && token.claims.userid !== currentUserId ) {
       logger.log(`security.storageEventListener: User has changed ${JSON.stringify(event)}`, options.isLoggingEnabled);
       router.push({name: 'home'}); 
      } 
    });
     router.beforeEach(async (to, from, next) => {
      logger.log('security.router.beforeEach: Beginning.', options.isLoggingEnabled);
      if (to.matched.some(record => record.meta.requiresAuth) &&
         !await Vue.prototype.$auth.isAuthenticated()) {
        logger.log('security.router.beforeEach: User is not authenticated, signing out.', options.isLoggingEnabled);
        sessionStorage.setItem('callbackUrlSessionItem', to.fullPath);
        // await Vue.prototype.$security.signOut();
       return next({ path: '/' });
        }
       next();
      });


   axios.interceptors.response.use((config) => { return config; },
    async (error) => {
      if (error.response && error.response.status === 401) {
        logger.error(`security.responseInterceptor: Signing out because of response error: ${JSON.stringify(error)}`, options.isLoggingEnabled);
        await Vue.prototype.$security.signOut(router.history.current.fullPath);
      }
      return Promise.reject(error);
    });
  
    axios.interceptors.request.use(async (config) => {
      logger.log(`security.requestInterceptor: Beginning. config: ${JSON.stringify(config)}`, options.isLoggingEnabled);
      if (Vue.prototype.$security.isWhiteListed(config.url))
       return config;
      await Vue.prototype.$security.refreshToken();
      const token = await Vue.prototype.$auth.tokenManager.get('accessToken');
      logger.log('security.requestInterceptor: Is user authenticated?', options.isLoggingEnabled);
      if (!token) 
      Vue.prototype.$security.signOut();
      config.headers.Authorization = `Bearer ${token.accessToken}`;
     return config;
    }, (error) => {
      logger.error(`security.requestInterceptor: Request error: ${JSON.stringify(error)}`, options.isLoggingEnabled);
    });
    Vue.prototype.$security = {
      isWhiteListed: (url) => {
        return options.authentication.whitelist.routes.find((item) => item === router.history.current.name) ||
          options.authentication.whitelist.apis.find((item) => item === url)
      },
      beginAuthentication: async () => {     
        logger.log('security.beginAuthentication: Begginning.', options.isLoggingEnabled);
        const isAuthenticated = await Vue.prototype.$auth.isAuthenticated();
        logger.log('security.beginAuthentication: Is user authenticated?', options.isLoggingEnabled);
        if (isAuthenticated) {
          logger.log('security.beginAuthentication: User is authenticated, abandoning.', options.isLoggingEnabled);
          return;
        }
        logger.log('security.beginAuthentication: Redirecting to sign in.', options.isLoggingEnabled);
        await Vue.prototype.$auth.signInWithRedirect({ originalUri: options.authentication.authenticationRoutePath });
      },
      completeAuthentication: async () => {
        console.log('security.completeAuthentication: Beginning.', options.isLoggingEnabled);
        const isAuthenticated = await Vue.prototype.$auth.isAuthenticated();
        console.log('security.completeAuthentication: Is user authenticated?', options.isLoggingEnabled);
        if (!isAuthenticated) {
          console.log('security.completeAuthentication: User is Not authenticated, abandoning.', options.isLoggingEnabled);
          return;
        }
        return await Vue.prototype.$security.session.initialize().then(async () => {
          let callbackUrl = sessionStorage.getItem('callbackUrlSessionItem');
          sessionStorage.removeItem('callbackUrlSessionItem');
          if (!callbackUrl)
            callbackUrl = options.authentication.defaultRedirectRoutePath;
          console.log(`security.completeAuthentication: Completed, redirecting user to ${callbackUrl}`, options.isLoggingEnabled);
          router.push(callbackUrl);

        });
      },
      signOut: async (redirectPath) => {
        if (redirectPath) {
          sessionStorage.setItem(callbackUrlSessionItem, redirectPath);
        }   
        var re=Vue.prototype.$auth.signOut();
        store.commit('clearSessionData');
        sessionStorage.clear();
        localStorage.clear();
        await re;
      },
      isAccessTokenExpired: async () => {
        const refreshEarlyBy = options.authentication.refresh.activeThresholdSeconds * 1000;
        const accessToken = await Vue.prototype.$auth.tokenManager.get('accessToken');
        if (!accessToken)
          return true;
        var refreshIn = (accessToken.expiresAt * 1000) - Date.now() - refreshEarlyBy; // Milliseconds until refresh
        logger.log(`security.isAccessTokenExpired: Refreshing access token in: ${refreshIn / 1000} seconds.`, options.isLoggingEnabled);
        return (refreshIn < 1);
      },
      isIdTokenExpired: async () => {
        const refreshEarlyBy = options.authentication.refresh.activeThresholdSeconds * 1000;
        const idToken = await Vue.prototype.$auth.tokenManager.get('idToken');
        logger.log(`security.isIdTokenExpired: Retrieved ID Token ${idToken}`, options.isLoggingEnabled);
        if (!idToken)
          return true;
        var refreshIn = (idToken.expiresAt * 1000) - Date.now() - refreshEarlyBy; // Milliseconds until refresh
        logger.log(`security.isIdTokenExpired: Refreshing ID token in: ${refreshIn / 1000} seconds.`, options.isLoggingEnabled);
        return (refreshIn < 1);
      },
      refreshToken: async () => {
        logger.log('security.refreshToken: Beginning.', options.isLoggingEnabled);
        return mutex.runExclusive(async () => {
          if (await Vue.prototype.$security.isIdTokenExpired()) {
            await Vue.prototype.$auth.tokenManager.renew('idToken')
              .then((result) => {
                logger.log('security.refreshToken: Id Token refreshed.',options.isLoggingEnabled);
              })
              .catch(() => {});
          }
          if (!(await Vue.prototype.$security.isAccessTokenExpired())) {
            logger.log('security.refreshToken: Access token hasn\'t expired.', options.isLoggingEnabled);
          } else {
            await Vue.prototype.$auth.tokenManager.renew('accessToken')
            .then((result) => {
              logger.log('security.refreshToken: Access Token refreshed.',options.isLoggingEnabled);
            })
            .catch(() => {});
          }
          
        });
      },
      session: {
        initialize: async () => {
          return axios({
            method: 'GET',
            url: '/users/session',
          }).then((response) => {
            sessionStorage.setItem('userAgency', response.data.agency);
            sessionStorage.setItem('permissions', response.data.permissions);
            sessionStorage.setItem('agencyId', response.data.agencyId);
            sessionStorage.setItem('userId', response.data.userId);
            sessionStorage.setItem('username', response.data.username);
            sessionStorage.setItem('tokenType', 'Bearer');
          }).catch((error) => {
            logger.error(`security.session.initialize: Unable to get authenticated user\'s session data: ${JSON.stringify(error)}`, options.isLoggingEnabled);
            return Promise.reject(error);
          });
        },
      },
    }    
  },
}


// WEBPACK FOOTER //
// ./src/security/security.js